<div class="sub-menu-root-container system-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('region')" class="mat-list-item"
            routerLink="/system/region" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Region' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/region.svg">
                <span class="master-title" style="word-wrap: break-word;">Region
                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('department')" class="mat-list-item"
            routerLink="/system/department" [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Department' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/department.svg">
                <span class="master-title">Department</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('kitchen')" class="mat-list-item"
            routerLink="/system/kitchen" [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Kitchen' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/kitchen.svg">
                <span class="master-title"> Kitchen
                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'SHOP' && hasAccess('station')" class="mat-list-item"
            routerLink="/system/station" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Station' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/terminal.svg">
                <span class="master-title">Station
                </span>
            </div>
        </mat-list-item>
        <mat-list-item class="mat-list-item" *ngIf="hasAccess('shop')"
            [routerLink]="userData?.user_type === 'SHOP' ? '/system/shop-edit/' + userData?.shop_id : '/system/shop'"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Shop' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/shop.svg">
                <span class="master-title"> Shop{{userData?.user_typ}}
                </span>
            </div>
        </mat-list-item>
        <mat-list-item class="mat-list-item" *ngIf="hasAccess('system-settings')" routerLink="/system/system-settings"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Settings' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/settings.svg">
                <span class="master-title">Settings</span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('expense')" class="mat-list-item"
            routerLink="/system/expense" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Expense' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/expense.svg">
                <span class="master-title">Expense
                </span>
            </div>
        </mat-list-item>
        <!-- <mat-list-item *ngIf="userData?.user_type === 'HQ'" class="mat-list-item" routerLink="/expense-type"
                    [routerLinkActive]="['is-active']" (click)="resetState()"
                    [matTooltip]="!show ? 'Staff Payroll' : ''" matTooltipPosition="right"
                    matTooltipClass="mat-tooltip">
                    <div class="mat-list-item-contents">
                        <img src="assets/images/menu/svg/expense-type.svg">
                        <span class="master-title">Expense Type
                        </span>
                    </div>
                </mat-list-item> -->
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('reason')" class="mat-list-item"
            routerLink="/system/reason" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Reason' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/reasons.svg">
                <span class="master-title">Reason
                </span>
            </div>
        </mat-list-item>
        <!-- <mat-list-item *ngIf="userData?.user_type === 'HQ'" class="mat-list-item" routerLink="under-construction" [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Attendance Data' : ''"  matTooltipPosition="right" matTooltipClass="mat-tooltip">
                    <div class="mat-list-item-contents">
                        <img src="assets/images/menu/svg/shop.svg">
                        <span class="master-title">Shop Shift
                        </span>
                    </div>
                </mat-list-item> -->



    </div>
</div>